import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import { Card, StepLabel, Tooltip} from '@material-ui/core';
import PropTypes from "prop-types";
import {bbDangerousStringToDate, bbFormattedDateString, bbIsObject} from "../../../util/bbHelpers";
import BBIconHourglass from "../../../assets/bbCustomIcons/BBIconHourglass";
import BBIconShieldSimpleWarning from "../../../assets/bbCustomIcons/BBIconShieldSimpleWarning";
import ExitToAppSharpIcon from "@material-ui/icons/ExitToAppSharp";
import BBIconShieldSimpleCheck from "../../../assets/bbCustomIcons/BBIconShieldSimpleCheck";
import Skeleton from "react-loading-skeleton";
import BBIconHistory from "../../../assets/bbCustomIcons/BBIconHistory";
import BBIconInProgressPie from "../../../assets/bbCustomIcons/BBIconInProgressPie";
import BBIconCalendarPlus from "../../../assets/bbCustomIcons/BBIconCalendarPlus";
import BBIconAbortStop from "../../../assets/bbCustomIcons/BBIconAbortStop";
import {Badge} from "reactstrap";
//
// const useStyles = makeStyles(theme => ({
//     root: {
//         width: '100%',
//     },
//     button: {
//         marginRight: theme.spacing(2),
//     },
//     completed: {
//         display: 'inline-block',
//     },
//     instructions: {
//         fontSize: "smaller",
//         marginBottom: theme.spacing(1),
//         fontStyle: 'italic',
//     },
// }));

// function getSteps() {
//     return ['Identify', 'Recon', 'Attack', "Breach"];
// }

// function stepTipDescriptions() {
//     return {
//         'Identify' : "Recognition that the indicated target might be susceptible to a BreachBits attack capability.",
//         'Recon' : "Gathering more information about the target, e.g. to determine if the indicated attack capability will be effective.",
//         'Attack' : "Preparing, conducting, and analyzing the results of attack actions; launching the capability against the target.",
//         "Breach" : "One or more attacks have been successful, and analyzing the results."
//     }
// }

const phaseStatusIconLibrary = (phase) => {
    if (bbIsObject(phase) && phase.hasOwnProperty("Status")) {
        switch(phase.Status.Id) {
            case 0: //planned
                return <BBIconCalendarPlus className={"text-electric-blue "}/>
            case 1: //ongoing
                return <BBIconInProgressPie className={"text-electric-blue "}/>
            case 2: //stopped (aborted)
                return <BBIconAbortStop className={"text-grey"}/>
            case 3: //full success
                return <ExitToAppSharpIcon className={"text-bb-risk-highest"}/>
            case 4: //partial success
                return <BBIconShieldSimpleWarning className={"text-bb-risk-high"}/>
            case 5: //unsuccessful (defended)
                return <BBIconShieldSimpleCheck className={"text-bb-risk-lowest"}/>


            default:
                return <BBIconHourglass className={"text-light-grey"}/>
        }

    } else {
        return null
    }
}

const InsiderAttackStepper = (props) => {

    // const classes = useStyles();
    const {attackObject, showOnlyLast = null, isVertical=false, isLoading = false} = props;

    const attackPhasesMeta =() => {
        if (bbIsObject(attackObject) && attackObject.hasOwnProperty("Phases") && bbIsObject(attackObject.Phases)) {
            const tipDescriptions = {}
            for (const [phaseId, phase] of Object.entries(attackObject.Phases)) {
                tipDescriptions[phase.Id] = {
                    description: `(${phase.Status.Name}) ${phase.Phase.Description} | Started: ${bbFormattedDateString(phase["Started DateTime"], "utc") } | Completed: ${bbFormattedDateString(phase["Completed DateTime"], "utc")}`,
                    completed: phase.Status.Id !== 1,
                    startDate: phase["Started DateTime"] ? bbFormattedDateString(phase["Started DateTime"], "microYear") : null,
                    completedDate: phase["Completed DateTime"] ? bbFormattedDateString(phase["Completed DateTime"], "microYear") : null,
                    icon: phaseStatusIconLibrary(phase)
                }
            }
            if(showOnlyLast) {
                tipDescriptions["…"] = {
                    description: `Previous phases are not displayed. Only showing the ${showOnlyLast} most recent phases (of ${Object.keys(attackObject.Phases).length} total).`,
                    completed: false,
                    startDate: null,
                    completedDate: null,
                    icon: <BBIconHistory className={"text-light-grey"}/>
                }
            }
            if(isLoading) {
                tipDescriptions["Loading..."] = {
                    description: ``,
                    completed: false,
                    startDate: null,
                    completedDate: null,
                    icon: <BBIconHourglass className={"text-light-grey"}/>
                }
            }
            return tipDescriptions;

        } else if (isLoading) {
            const tipDescriptions = {}
            if(isLoading) {
                tipDescriptions["Loading..."] = {
                    description: ``,
                    completed: false,
                    icon: <BBIconHourglass className={"text-light-grey"}/>
                }
            }
            return tipDescriptions;
        } else {
            return null
        }
    }

    const attackPhasesAsArray = () => {
        if (bbIsObject(attackObject) && attackObject.hasOwnProperty("Phases") && bbIsObject(attackObject.Phases)) {
            let phasesArray = []
            for (const [phaseId, phase] of Object.entries(attackObject.Phases)) {
                phasesArray.push(phase);
            }

            //now sort by date
            phasesArray.sort((a,b) => bbDangerousStringToDate(a["Started DateTime"]) - bbDangerousStringToDate(b["Started DateTime"]));

            return phasesArray;
        } else {
            return null
        }

    }

    const sortedPhases = attackPhasesAsArray();

    const getSteps =() => {
        if (isLoading){
            return [{
                name: "Ghost...1",
                id: "Loading..."
            }, {
                name: "Ghost...2",
                id: "Loading..."
            }, {
                name: "Ghost...3",
                id: "Loading..."
            }, {
                name: "Ghost...4",
                id: "Loading..."
            }]
        } else {
            let usePhases = sortedPhases;
            const totalPhases = sortedPhases.length;
            if(showOnlyLast) {
                usePhases = sortedPhases.slice(0).slice(0-showOnlyLast)

            }
            //now add a blank line to beginning
            usePhases = usePhases.map((phase) => {
                return {
                    name: phase.Phase.Name,
                    id: phase.Id
                }
            });

            if(showOnlyLast && showOnlyLast < totalPhases) {
                usePhases.unshift({
                    name: `(${totalPhases - usePhases.length} hidden)`,
                    id: "…"
                });
            }

            return usePhases;
        }

    }

    const steps = getSteps();
    const stepMeta = attackPhasesMeta();

    return (
        <Card className={"my-3 px-2 py-2"}>
            <h3 className={"text-center"}>Phase Progression</h3>
            {bbIsObject(attackObject) && attackObject.hasOwnProperty("Phases") && bbIsObject(attackObject.Phases) &&
                <div className={"text-center"}>
                    <Tooltip title={`${Object.keys(attackObject.Phases).length} phases have been completed, planned, or are in progress.  A Phase represents an intermediate objective or significant event in pursuit of the overall Attack Objective. If the attack is still ongoing, more phases could occur.`}>
                        <span>
                            <Badge color={"electric-blue-light"}>{Object.keys(attackObject.Phases).length} Phases</Badge>
                        </span>
                    </Tooltip>
                </div>
            }
            {steps.length
                ? <Stepper nonLinear={!isVertical} alternativeLabel = {!isVertical} activeStep={steps.length - 1} orientation={isVertical ? "vertical" : "horizontal"}>
                    {steps.map((stepObject) => (
                        <Step key={`${stepObject.id}_${stepObject.name}`}>
                            <Tooltip title={stepMeta[stepObject.id].description}>
                                <StepLabel
                                    icon={stepMeta[stepObject.id].icon}
                                >
                                    {isLoading
                                        ? <Skeleton/>
                                        : stepObject.name
                                    }
                                    {stepMeta[stepObject.id].completedDate
                                        ? <><br/><small><em>{`Completed ${stepMeta[stepObject.id].completedDate}`}</em></small></>
                                        : stepMeta[stepObject.id].startDate
                                            ? <><br/><small><em>{`Started ${stepMeta[stepObject.id].startDate}`}</em></small></>
                                            : stepObject.id === "Loading..."
                                                ? <><br/><small><em><Skeleton/></em></small></>
                                                : stepObject.id === "…"
                                                    ? null
                                                    : <><br/><small><em>{`Not yet started.`}</em></small></>
                                    }

                                </StepLabel>
                            </Tooltip>
                        </Step>
                    ))}
                </Stepper>
                : <div className={"text-center"}><em >No phase progression elements to display.</em></div>
            }

            {/*<Box>*/}
            {/*    <Box>*/}
            {/*        <Typography className={classes.instructions}>{sortedPhases.lastItem.Phase.Description}</Typography>*/}
            {/*    </Box>*/}
            {/*</Box>*/}
        </Card>
    );
}

InsiderAttackStepper.propTypes = {
    attackObject: PropTypes.object.isRequired,
    showOnlyLast: PropTypes.number,
    isVertical: PropTypes.bool,
    isLoading: PropTypes.bool,
};

export default withStyles(null, {withTheme: true})(InsiderAttackStepper);